import {EventBus} from "../../../../../common/ts/events/EventBus";
import {WhitelabelEvent} from "../../../../../common/ts/events/Events";
import {PostEvent} from "../../../../../common/ts/core/http";
import {SaveWebPushAlertRequestedEvent, ShowWebPushRequestedEvent} from "./events";
import tracking from "../../../../../common/ts/core/tracking";
import {SECTION_BROWSER_PUSH_NOTIFICATION} from "./constants";
import {ShowGoogleOneTapRequestedEvent} from "../../../serp/googleOneTap/events";
import {Device} from "../../../../../common/ts/types/Device";
import {hasConsentForGoogleCookies, hasGoogleOneTapAlreadyBeenPrompted} from "../../../serp/googleOneTap/googleOneTap";

let eventBus: EventBus;

export function saveWebPushAlertRequestedEventHandler(event: WhitelabelEvent) {
    const { payload: { search, subscription } } = event as SaveWebPushAlertRequestedEvent;
    const key = subscription.getKey("p256dh");
    const auth = subscription.getKey("auth");

    if (key && auth) {
        const body = {
            'what': search,
            'endpoint': subscription.endpoint,
            'auth': arrayBufferToBase64(auth),
            'key': arrayBufferToBase64(key),
            'action': '6',
        }
        const urlParams = new URLSearchParams(window.location.search);
        const host = urlParams.get('host');

        eventBus.emit(new PostEvent({ url: retentionUrlEventHandler()+ "/servletGestionAlertas?host=" + window.location.hostname, body, formUrlencoded: true }));
    }
}
function retentionUrlEventHandler() {
    if (window.location.hostname.includes(".local.")) {
        return "http://retention.local.mitula.com";
    } else if (window.location.hostname.includes(".dev.")) {
        return "https://retention.dev.mitula.com";
    } else {
        return "https://retention.mitula.com";
    }
}
export async function showWebPushRequestedEventHandler(event: WhitelabelEvent) {
    const { payload: { search, pageviewId, device, showGoogleOneTapAfter } } = event as ShowWebPushRequestedEvent;
    await navigator.serviceWorker.register('/sw.js');
    await checkPermissions(search, pageviewId, device, showGoogleOneTapAfter);
}

async function checkPermissions(search: string, pageviewId: string, device: string, showGoogleOneTapAfter: boolean) {
    if (isFromSafariBrowser()) {
        await handleSafariPermissions(search, pageviewId, device, showGoogleOneTapAfter);
    } else if (isBrowserCompatibleWithWPN()) {
        await handlePermissions(search, pageviewId, device, showGoogleOneTapAfter);
    }
}

function isFromSafariBrowser() {
    const userAgent = navigator.userAgent.toLowerCase();
    // @ts-ignore
    return (userAgent.indexOf('safari') !== -1 && 'safari' in window && 'pushNotification' in window.safari);
}

async function handleSafariPermissions(search: string, pageviewId: string, device: string, showGoogleOneTapAfter: boolean) {
    // @ts-ignore
    const permissionData = window.safari.pushNotification.permission('web.com.mitula.homes');
    if (permissionData.permission === 'default') {
        // @ts-ignore
        window.safari.pushNotification.requestPermission(
            'https://www.mitula.com/',
            'web.com.mitula.homes',
            {},
            handleSafariPermissions
        );
    } else if (permissionData.permission === 'denied') {
        if (
            showGoogleOneTapAfter &&
            device == Device.MOBILE &&
            hasConsentForGoogleCookies() &&
            !hasGoogleOneTapAlreadyBeenPrompted()
        ) {
            eventBus.emit(new ShowGoogleOneTapRequestedEvent());
        }
    } else if (permissionData.permission === 'granted') {
        eventBus.emit(new tracking.TrackWebTrackingEvent({
            type: "WebPushAllowed",
            serpUrl: window.location.href,
            section: SECTION_BROWSER_PUSH_NOTIFICATION.toString(),
            pageViewId: pageviewId,
        }));

        await subscribe(search);

        if (
            showGoogleOneTapAfter &&
            device == Device.MOBILE &&
            hasConsentForGoogleCookies() &&
            !hasGoogleOneTapAlreadyBeenPrompted()
        ) {
            eventBus.emit(new ShowGoogleOneTapRequestedEvent());
        }
    }
}

async function handlePermissions(search: string, pageviewId: string, device: string, showGoogleOneTapAfter: boolean) {
    if (Notification.permission === 'default') {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            trackWebPushGranted(pageviewId);
            await subscribe(search);
        } else {
            trackWebPushDenied();
        }

        if (
            showGoogleOneTapAfter &&
            device == Device.MOBILE &&
            hasConsentForGoogleCookies() &&
            !hasGoogleOneTapAlreadyBeenPrompted()
        ) {
            eventBus.emit(new ShowGoogleOneTapRequestedEvent());
        }
    } else if (Notification.permission === 'granted') {
        await subscribe(search);

        if (
            showGoogleOneTapAfter &&
            device == Device.MOBILE &&
            hasConsentForGoogleCookies() &&
            !hasGoogleOneTapAlreadyBeenPrompted()
        ) {
            eventBus.emit(new ShowGoogleOneTapRequestedEvent());
        }
    } else if (Notification.permission === 'denied') {
        if (
            showGoogleOneTapAfter &&
            device == Device.MOBILE &&
            hasConsentForGoogleCookies() &&
            !hasGoogleOneTapAlreadyBeenPrompted()
        ) {
            eventBus.emit(new ShowGoogleOneTapRequestedEvent());
        }
    }
}

async function subscribe(search: string) {
    eventBus.emit(new SaveWebPushAlertRequestedEvent({
        search,
        subscription: await getWPNSubscription(),
    }));
}

async function getWPNSubscription() {
    const swRegistration = await navigator.serviceWorker.ready;
    let subscription = await swRegistration.pushManager.getSubscription();
    if (!subscription) subscription = await createSubscription(swRegistration);
    return subscription;
}

async function createSubscription(swRegistration: ServiceWorkerRegistration) {
    return swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array('BPmq6GEKK3iyoIZuXqAEmPMlukYdFTXm8NmqsQmQlxZA8Xb-RIj4uGVeIWSS3inXbpmxhvptfdHJSrILUW2o4CI'),
    });
}

const urlBase64ToUint8Array = (base64String: string) => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
};

function isBrowserCompatibleWithWPN(): boolean {
    return 'PushManager' in window && 'showNotification' in ServiceWorkerRegistration.prototype;
}

function trackWebPushDenied() {
    eventBus.emit(new tracking.TrackAnalyticsEvent({name: 'wpn-retention-block'}));
}

function trackWebPushGranted(pageviewId: string) {
    eventBus.emit(new tracking.TrackAnalyticsEvent({ name: 'wpn-retention-allow' }));
    eventBus.emit(new tracking.TrackWebTrackingEvent({
        type: "WebPushAllowed",
        serpUrl: window.location.href,
        section: SECTION_BROWSER_PUSH_NOTIFICATION.toString(),
        pageViewId: pageviewId,
    }));
}

const arrayBufferToBase64 = (arrayBuffer: ArrayBuffer) => {
    return btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(arrayBuffer))));
}

function init(ev: any = EventBus.getInstance()) {
    eventBus = ev;
    eventBus.subscribe(ShowWebPushRequestedEvent.TYPE, showWebPushRequestedEventHandler);
    eventBus.subscribe(SaveWebPushAlertRequestedEvent.TYPE, saveWebPushAlertRequestedEventHandler);
}

export default {
    init,
};
